import { render, staticRenderFns } from "./StepsList.vue?vue&type=template&id=3c96d1c9&scoped=true"
import script from "./StepsList.vue?vue&type=script&lang=js"
export * from "./StepsList.vue?vue&type=script&lang=js"
import style0 from "./StepsList.vue?vue&type=style&index=0&id=3c96d1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96d1c9",
  null
  
)

export default component.exports